import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/style.css'; 
import {I18nextProvider} from "react-i18next";
import i18next from "i18next"; 
import common_de from "./lang/de/common.json";
import common_en from "./lang/en/common.json";
import common_it from "./lang/it/common.json";
import { ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import Helmet from "react-helmet"
 

i18next.init({
  interpolation: { escapeValue: false },   
  lng: 'de',                               
  resources: {
      en: {
          common: common_en                
      },
      de: {
          common: common_de
      },
      it: {
        common: common_it
    },
  },
});


 
ReactDOM.render(
  <React.StrictMode> 
     <I18nextProvider i18n={i18next}>
     <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />
      <App /> 
     </I18nextProvider> 
  </React.StrictMode>,
  document.getElementById('root')
);
